import React from "react";
import { Redirect } from "react-router";
import branchServerClient from "web/core/branchServerClient";
import Spinner from "theme/components/atoms/Spinner";

const makeAbsoluteUrl = (url) => (url.startsWith("/") ? url : `/${url}`);

const isExternal = (url) => url.match(/^https?:\/\//);

const ServerRedirect = ({ entity }) => {
  if (isExternal(entity.redirectTo)) {
    return <Redirect to={entity.redirectTo} />;
  }
  return <Redirect to={makeAbsoluteUrl(entity.redirectTo)} />;
};

const ClientRedirect = ({ entity }) => {
  if (isExternal(entity.redirectTo)) {
    window.location.href = entity.redirectTo;
    return <Spinner />;
  }
  return <Redirect to={makeAbsoluteUrl(entity.redirectTo)} />;
};

export default branchServerClient(
  () => ServerRedirect,
  () => ClientRedirect,
  { preferClientSide: true }
)(null);
